import * as React from 'react';

import type {UserContentSubscriptionsExternal} from 'src/types/content-subscription';
import {Button} from 'src/components/lib/new-button';
import Success from './success';
import DebugEntityMessage from './debug-entity-message';
import Toggle from 'src/components/lib/toggle/toggle';
import classify from 'src/utils/classify';

import css from './style.css';


type Props = {
  success: boolean;
  isDebugEntity: boolean;
  attributeValue: string;
  userContentSubscriptionsLocal: UserContentSubscriptionsExternal;
  onSubscriptionToggle: (arg1: number, arg2: boolean) => unknown;
  onSave: () => unknown;
};

const ContentCategoryManagement = ({
  success,
  isDebugEntity,
  attributeValue,
  userContentSubscriptionsLocal,
  onSubscriptionToggle,
  onSave,
}: Props) => {
  if (success) {
    return <Success />;
  } else if (isDebugEntity) {
    return (
      <div>
        <DebugEntityMessage />
      </div>
    );
  } else {
    return (
      <div>
        <div className={css.unsubscribePage}>
          <label>
            Hey , You can opt-in/opt-out marketing content categories here for
            &nbsp;<b>{attributeValue}</b>
          </label>

          <div className={css.subscriptionCategoriesContainer}>
            {userContentSubscriptionsLocal.map(
              ({
                content_subscription_category_id,
                name,
                description,
                subscription,
              }) =>
                subscription[0] && (
                  <div
                    className={classify(css.categoryBox, {
                      [css.subscribedCategory]: subscription[0].is_subscribed,
                    })}
                  >
                    <div className={css.categoryBoxTitle}>
                      <span>{name}</span>
                      <Toggle
                        checked={subscription[0].is_subscribed}
                        onChange={(event) => {
                          onSubscriptionToggle(
                            content_subscription_category_id,
                            event.target.checked,
                          );
                        }}
                      />
                    </div>
                    <div className={css.categoryBoxDescription}>
                      {description}
                    </div>
                  </div>
                ),
            )}
          </div>

          <Button
            className={css.unsubscribeButton}
            type="primary"
            size="large"
            onClick={onSave}
          >
            Save Preference
          </Button>
        </div>
      </div>
    );
  }
};

export default ContentCategoryManagement;
